export default "__VITE_ASSET__BCaaggMd__"